export default __webpack_public_path__ + "static/media/4861.241f3a94.png";